import { Chip, ChipProps } from '@mui/material';
import colors from 'assets/theme/base/colors';

const StatusChip: React.FC<{ status: string, value?: number | string, displayNumber?: boolean, columnName?: string } & ChipProps> = ({ status, value, displayNumber, columnName, ...props }) => {
	let bgColor = `${colors.backgroundLight.dark}`;
	let color = '#fff';
	status = status ? status : '--'
	switch (status?.toUpperCase()) {
		case 'SUCCESS':
		case 'SUCCESSFUL':
		case 'YES':
		case 'COMPLETED':
		case 'ONLINE':
		case 'CLOSED':
		case 'SUCCEEDED':
			bgColor = '#01c008';
			color = '#eff7ef';
			break;

		case 'IP_DELAYED_START':
			bgColor = 'rgba(0, 96, 179, 0.2)';
			color = 'rgb(54, 168, 255, 1)';
			break;

		case 'OPEN':
			bgColor = `${colors.backgroundLight.dark}`;
			color = '#e8f1f8';
			break;

		// ── Light-theme statuses for the DAI dashboards ──────────────────────
		// The DAI tables render on a white panel, so these reuse the
		// `.status-badge` palette in DataAssetIntelligence.scss rather than the
		// dark-theme colours above (which rendered as white-on-white chips).
		case 'ON TIME':
			bgColor = '#e3f7e9';
			color = '#1e8e3e';
			break;

		case 'EXPECTED TODAY':
			bgColor = '#e4f2ff';
			color = '#1565a8';
			break;

		case 'NOT EXPECTED TODAY':
			bgColor = '#eeeeee';
			color = '#666';
			break;

		case 'NOT AVAILABLE':
		case 'SCHEDULE UNKNOWN':
		case 'SCHEDULE MISSING':
		case 'NOT DUE':
			bgColor = '#fff3d9';
			color = '#9a6a00';
			break;

		case 'MISSED':
			bgColor = '#fde3e1';
			color = '#c8341f';
			break;

		case 'NO SLA TIME':
			bgColor = '#eef1f6';
			color = '#536476';
			break;

		case 'NOT APPLICABLE':
			bgColor = '#eeeeee';
			color = '#888';
			break;

		case 'FAILURE':
		case 'TERMINATED':
		case 'SUSPENDED':
		case 'NO':
		case 'FAILED':
			bgColor = columnName == 'jobStatus' ? 'rgba(216, 43, 81, 0.3)' : '#3d2033';
			color = columnName == 'jobStatus' ? 'rgba(216, 43, 81, 1)' : '#cd2429';
			break;


		case 'IN PROGRESS':
			bgColor = 'rgba(255, 162, 0, 0.3)';
			color = 'rgba(255, 162, 0, 1)';
			break;

		case 'LONG RUNNING':
			bgColor = 'rgba(255, 162, 0, 0.2)';
			color = 'rgba(255, 162, 0, 1)';
			break;

		case 'SLA MISSED':
			bgColor = 'rgba(253, 120, 59, 0.3)';
			color = 'rgba(253, 120, 59, 1)';
			break;

		case 'Not Met':
		case 'NOT MET':
		case 'Sla Missed':
		case 'IN PROGRESS':
			bgColor = 'rgba(255, 162, 0, 0.2)';
			color = 'rgba(255, 162, 0, 1)';
			break;

		case 'ACTUAL_COMPLETION_TIME':
			color = 'rgba(216, 43, 81, 1)'
			//color =  'rgba(255, 255, 255, 1)';
			break;

		case 'NOT STARTED':
			bgColor = '#eeeeee';
			color = '#666';
			break;

		case 'N/A':
		case 'NA':
		case 'Scheduled':
		case 'SCHEDULED':
			bgColor = 'rgba(169, 173, 203, 0.6)';
			color = '#000';
			break;

		// case 'SCHEDULED':
		// 	bgColor = '#ffa20033';
		// 	color = '#ffa200';
		// 	break;

		case 'RUNNING':
		case 'ACTIVATED':
		case 'IN PROGRESS':
		case 'HOLD':
		case 'FROZEN':
			bgColor = 'rgb(254 38 38 / 28%)';
			color = 'rgb(254, 38, 38)';
			break;

		case 'SLA MET':
		case 'MET':
		case 'Sla Met':
		case 'HEALTHY':
		case 'SUCCESSFUL':
			bgColor = 'rgba(1, 192, 8, 0.2)';
			color = 'rgba(1, 192, 8, 1)';
			break;
		case 'OFFLINE':
		case 'THROTTLED':
			bgColor = 'rgb(253 120 59 / 0.7)';
			color = 'rgb(253, 120, 59)';
			break;
		case 'RISK':
			bgColor = 'rgb(236 185 20 / 0.7)';
			color = 'rgb(236, 185, 20)';
			break;
		case 'DELAYEDSTART':
		case 'DELAYED':
			bgColor = value == '--' ? 'transparent' : 'rgba(255, 56, 176, 0.2)';
			color = value == '--' ? '#F5F5F5' : 'rgba(255, 56, 176, 1)';
			break;
		case 'NOT SCHEDULED':
			bgColor = value == '--' ? 'transparent' : '#2a4444';
			color = value == '--' ? '#F5F5F5' : '#F5F5F5';
			break;
		case 'FAILED TO START':
			bgColor = value == '--' ? 'transparent' : 'rgba(160, 129, 255, 0.2)';
			color = value == '--' ? '#F5F5F5' : 'rgba(160, 129, 255, 1)';
			break;
		case 'LONG RUNNING':	
		case 'LONGRUNNING':
			bgColor = value == '--' ? 'transparent' : 'rgba(253, 149, 50, 0.2)';
			color = value == '--' ? '#F5F5F5' : 'rgba(253, 149, 50, 1)';
			break;
		case 'JOBSFAILED':
			bgColor = value == '--' ? 'transparent' : 'rgba(254, 38, 38, 0.15)';
			color = value == '--' ? '#F5F5F5' : 'rgba(254, 38, 38, 1)';
			break;
		case 'JOBSSUCCESS':
			bgColor = value == '--' ? 'transparent' : 'rgba(1, 192, 8, 0.2)';
			color = value == '--' ? '#F5F5F5' : 'rgba(1, 192, 8, 1)';
			break;
		case 'PROJECTSLASTATUS':
			bgColor = value == '--' ? 'transparent' : value == 'SLA Met' ? 'rgba(1, 192, 8, 1)' : value == 'SLA Missed' ? 'rgba(216, 43, 81, 1)' : value == 'Scheduled' ? 'rgba(136, 142, 187)' : value == 'In Progress' ? 'rgba(236, 185, 20, 1)' : '#2a4444';
			color = value == '--' ? '#F5F5F5' : value == 'Scheduled' ? 'rgb(241, 242, 244)' : 'rgba(255, 255, 255, 1)';
			break;
		case '--':
			bgColor = 'transparent';
			color = '#fff';
			break;
		default:
			// Neutral light-theme fallback. The previous white-on-transparent
			// fallback was invisible against the white DAI table background.
			bgColor = '#eeeeee';
			color = '#555';
			break;
	}

	const chipProps: ChipProps = {
		label: displayNumber ? value : status,
		sx: {
			borderRadius: status == 'ProjectSLAStatus' || columnName == 'jobStatus' || columnName == 'totalExecutions' ? '50px' : '5px',
			'&.MuiChip-filled': {
				height: displayNumber ? '30px' : '20px',
				maxWidth: '100%',
				width: 'fit-content'
			},
			'&.MuiChip-filled, & .MuiChip-label': {
				fontWeight: 600,
				margin: 0,
				fontFamily: 'Montserrat',
				overflow: "hidden",
				textTransform: 'uppercase'
			},
			'& .MuiChip-label': {
				padding: '0 10px'
			},
			// !important is given, becoz mui chip style is being overridden by other css files, remove !important once css files are removed
			bgcolor: `${bgColor} !important`,
			color: `${color} !important`
		},
		...props
	};

	return <Chip {...chipProps} />;
};

export default StatusChip;
